import { Link } from "react-router-dom";

function HistoryGameweekCard({
  title,
  subtitle,
  status,
  highlight,
  points,
  exactScores,
  correctResults,
  deadlineUtc,
  lockUtc,
  to,
  state,
}) {
  const statusStyles = {
    completed: "bg-emerald-100 text-emerald-700",
    live: "bg-sky-100 text-sky-700",
    upcoming: "bg-slate-100 text-slate-700",
    open: "bg-amber-100 text-amber-700",
    locked: "bg-rose-100 text-rose-700",
  };

  const normalizedStatus = (status || "").toLowerCase();

  const fallbackHighlight =
    highlight ||
    (exactScores > 0
      ? `${exactScores} exact score${exactScores === 1 ? "" : "s"}`
      : correctResults > 0
      ? `${correctResults} correct result${correctResults === 1 ? "" : "s"}`
      : "No highlight yet");

  const formatDateTime = (value) => {
    if (!value) return "—";

    return new Date(value).toLocaleString([], {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const content = (
    <div className="rounded-3xl bg-white p-5 shadow-sm ring-1 ring-slate-200 transition hover:-translate-y-0.5 hover:shadow-md">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          <h4 className="text-lg font-semibold tracking-tight text-slate-900">
            {title}
          </h4>
          <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        </div>

        <span
          className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${
            statusStyles[normalizedStatus] || statusStyles.upcoming
          }`}
        >
          {status || "Upcoming"}
        </span>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-2xl bg-slate-50 p-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Highlight
          </p>
          <p className="mt-2 text-sm font-semibold text-slate-900">
            {fallbackHighlight}
          </p>
        </div>

        <div className="rounded-2xl bg-slate-50 p-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Points
          </p>
          <p className="mt-2 text-sm font-semibold text-slate-900">{points}</p>
        </div>
      </div>

      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <div className="rounded-2xl bg-slate-50 p-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Deadline
          </p>
          <p className="mt-2 text-sm text-slate-700">{formatDateTime(deadlineUtc)}</p>
        </div>

        <div className="rounded-2xl bg-slate-50 p-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Lock Time
          </p>
          <p className="mt-2 text-sm text-slate-700">{formatDateTime(lockUtc)}</p>
        </div>
      </div>
    </div>
  );

  if (to) {
    return (
      <Link to={to} state={state} className="block">
        {content}
      </Link>
    );
  }

  return content;
}

export default HistoryGameweekCard;